'use client';

import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
import { useState } from 'react';

export interface PolicyFaqItem {
  question: string;
  answer: string;
}

interface PolicyFaqProps {
  items: PolicyFaqItem[];
}

export function PolicyFaq({ items }: PolicyFaqProps) {
  const [openIndices, setOpenIndices] = useState<Set<number>>(new Set());

  const toggle = (index: number) => {
    setOpenIndices((prev) => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }

      return next;
    });
  };

  return (
    <div className="flex flex-col gap-20">
      <p className="px-20 font-700 tracking-[-0.4px] text-Gray-900 typo-h7">
        자주 묻는 질문
      </p>
      <div className="flex flex-col">
        {items.map((item, index) => {
          const isOpen = openIndices.has(index);

          return (
            <div
              key={index}
              className="flex flex-col items-start border-b border-Gray-300 bg-Gray-white px-20 py-16 last:border-b-0"
            >
              <button
                type="button"
                aria-expanded={isOpen}
                className="flex w-full items-start gap-8"
                onClick={() => toggle(index)}
              >
                <span className="whitespace-nowrap font-700 text-Gray-900 typo-body3">
                  Q.
                </span>
                <span className="flex-1 text-left font-700 tracking-[-0.28px] text-Gray-900 typo-body4">
                  {item.question}
                </span>
                <SvgChevrondown
                  className={cn(
                    'size-16 shrink-0 text-Gray-550 transition-transform duration-200',
                    isOpen && '-rotate-180',
                  )}
                />
              </button>
              <div
                aria-hidden={!isOpen}
                className={cn(
                  'grid w-full transition-[grid-template-rows] duration-300 ease-out',
                  isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
                )}
              >
                <div className="overflow-hidden">
                  <p className="pt-8 font-400 tracking-[-0.28px] text-Gray-700 typo-body4">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
